var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.562201 0.373439C0.860779 0.0863436 1.33556 0.095653 1.62266 0.394232L5.33203 4.33198L9.04141 0.394232C9.3285 0.0956531 9.80328 0.0863436 10.1019 0.373439C10.4004 0.660534 10.4098 1.13532 10.1227 1.4339L5.87266 5.9339C5.73125 6.08095 5.53605 6.16406 5.33203 6.16406C5.12802 6.16406 4.93281 6.08095 4.79141 5.9339L0.541407 1.4339C0.254312 1.13532 0.263622 0.660534 0.562201 0.373439Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorStroke);
export default __webpack_public_path__ + "static/media/Vector (Stroke).5eeb99a12dffe9055becef446f512cd9.svg";
export { ForwardRef as ReactComponent };